// make sticky the filters in the collection pages
(() => {
  try {
    const sentinel = document.querySelector('.template-collection facet-filters-form');
    const stickyElement = document.querySelector('.template-collection .facets-vertical .facets-wrapper');

    if (!sentinel || !stickyElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (window.innerWidth < 990) return;
        if (!entry.isIntersecting) {
          stickyElement.classList.add("margin-added");
        } else {
          stickyElement.classList.remove("margin-added");
        }
      },
      { root: null, threshold: 0 }
    );

    observer.observe(sentinel);
  } catch (e) {
    console.error("Sticky observer setup failed:", e);
  }
})();
// end sticky

(()=>{
  document.addEventListener("click", e=>{
    const target = e.target.closest(".link_list-heading");
    if(!target) return;

    const parent = target.closest(".footer-block--menu");

    const attributeValue = parent.getAttribute("data-open") || "false";
    if(attributeValue == "true") {
        parent.setAttribute("data-open", false);
    }else {
        parent.setAttribute("data-open", true);
    }
  })
})();